import baseApi from '@store/api/baseApi';

import { downloadBlobFileWithRTKQuery } from '@/utils/Util';
import { toastError } from '@/components/Toast';
import { closeLoader, openLoader } from '@/store/actions/LoaderAction';

export const commonDownloadsApi = baseApi.injectEndpoints({
	endpoints: (builder) => ({
		// Download Techpack Summary (excel file)
		downloadTpSummary: builder.mutation({
			query: ({ productIds, inventoryCountryIds }) => ({
				url: `/collection/download-report`,
				headers: {
					'Content-Disposition': 'attachment'
				},
				responseType: 'blob',
				responseHandler: async (response) => {
					await downloadBlobFileWithRTKQuery(response);
				},
				body: { productIds, inventoryCountryIds },
				method: 'POST',
				keepUnusedDataFor: 0
			}),
			onQueryStarted: async (_args, { queryFulfilled, dispatch }) => {
				try {
					dispatch(openLoader());
					await queryFulfilled;
				} catch ({ error }) {
					toastError(error?.data?.message || 'Something went wrong!');
				} finally {
					dispatch(closeLoader());
				}
			}
		}),
		// Download Sample Sticker
		downloadSticker: builder.mutation({
			query: ({ body, productIds, sampleIdentifierNos }) => ({
				url: `/product-sample-inventory/sticker/download?productIds=${productIds.join(',')}&sampleIdentifierNos=${sampleIdentifierNos.join(',')}`,
				method: 'POST',
				body,
				responseType: 'blob',
				responseHandler: async (response) => {
					await downloadBlobFileWithRTKQuery(response);
				}
			})
		}),
		downloadHandoverReport: builder.mutation({
			query: ({ params }) => ({
				url: '/collection/download-handover-report',
				headers: {
					'Content-Disposition': 'attachment'
				},
				method: 'POST',
				keepUnusedDataFor: 0,
				params,
				responseType: 'blob',
				responseHandler: async (response) => {
					await downloadBlobFileWithRTKQuery(response);
				}
			}),
			onQueryStarted: async (_args, { queryFulfilled, dispatch }) => {
				try {
					dispatch(openLoader());
					await queryFulfilled;
				} catch ({ error }) {
					toastError(error?.data?.message || 'Something went wrong!');
				} finally {
					dispatch(closeLoader());
				}
			}
		}),
		downloadTechpack: builder.mutation({
			query: ({ body, productId }) => ({
				url: `/product/download-techpack/${productId}`,
				method: 'POST',
				body,
				responseHandler: async (response) => {
					return response.text();
				}
			})
		})
	})
});

export const {
	useDownloadTpSummaryMutation,
	useDownloadStickerMutation,
	useDownloadHandoverReportMutation,
	useDownloadTechpackMutation
} = commonDownloadsApi;
